module.exports = __webpack_public_path__ + "static/media/landing-mdec-banner.a9000d4a.png";